// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spin_wrapper__1of-n","icon":"Spin_icon__1qK_D"};